/** Identifies the role of a sender for a given chat message. */
export enum Role {
  USER = 'user',
  ASSISTANT = 'assistant',
}
